import rp335 from "./rp335";
import rp336 from "./rp336";
import rp337 from "./rp337";
import rp338 from "./rp338";
import rp339 from "./rp339";
import rp340 from "./rp340";
import rp341 from "./rp341";
import rp342 from "./rp342";

export default {
    rp335,rp336,rp337,rp338,rp339,rp340,rp341,rp342
}